import { Component, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from "@angular/animations";
import { Compbaser } from "../../../components/compbaser";
import { ChildrenOutletContexts } from '@angular/router';
import { Memoizee } from "../../../decorators/memoizee-decorator";
import * as _ from "lodash";

@Component({
  selector: 'app-editor-entry',
  templateUrl: './editor-entry.component.html',
  styleUrls: ['./editor-entry.component.scss'],
  // host: {'unique-binding': _.uniqueId('comp_id')},
  animations: [
    trigger('fadeIn', [
      transition('* => *', [
        style({ opacity: 0 }),
        animate('300ms ease-in-out')
      ])
    ])
  ]
})
export class EditorEntryComponent extends Compbaser implements OnInit {

  constructor(private contexts: ChildrenOutletContexts) {
    super();
  }

  ngOnInit() {
  }

  @Memoizee({})
  getState() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['state'];
  }
}
